<!--社会责任-->
<template>
    <div>
      <transition name="moveing">
        <navgate-other ref="topTitle" v-show="isShowTopTitle" @lang-change="onLangChange"></navgate-other>
      </transition>

      <main class="index_main_content" ref="parentDiv">
        <div class="index_main_body other" ref="topDiv">
            <div class="zcgy_img"><img src="../../../assets/img/society/shehui-banner.jpg"><div class="mask_bg"></div></div>
            <div class="zcgy_word">
            <div class="zcgy_ch">{{ $t('society.banner.ch') }}</div>
            <div class="zcgy_en">{{ $t('society.banner.en') }}</div>
            </div>
        </div>
        <!--二级导航定格-->
        <div class="second_nav_top" v-show="lockSecondTop" >
          <div class="second_nav_list">
            <div :class="{active_d:(selectedSecond == 'report')}" @click="gotoPoint('report','report')">{{ $t('society.tabs.report') }}</div>
            <div :class="{active_d:(selectedSecond == 'esg')}" @click="gotoPoint('buildFuture','esg')">{{ $t('society.tabs.esg') }}</div>
            <div :class="{active_d:(selectedSecond == 'foundation')}" @click="clickSecondHandler('foundation')">{{ $t('society.tabs.foundation') }}</div>
          </div>
        </div>
        <!--二级导航-->
        <div class="second_nav" ref="secondNav">
          <div class="second_nav_list">
            <div :class="{active_d:(selectedSecond == 'report')}" @click="gotoPoint('report','report')">{{ $t('society.tabs.report') }}</div>
            <div :class="{active_d:(selectedSecond == 'esg')}" @click="gotoPoint('buildFuture','esg')">{{ $t('society.tabs.esg') }}</div>
            <div :class="{active_d:(selectedSecond == 'foundation')}" @click="clickSecondHandler('foundation')">{{ $t('society.tabs.foundation') }}</div>
          </div>
        </div>
        <!--内容-->
        <div class="aboutus_body_box">
        <div class="about_wenhua_layout" ref="report">
          <div class="web_title">{{ $t('society.report.title') }}</div>
          <div class="society_one">
            <div class="report_layout" v-if="(socityData && socityData.list.length > 0)" @click="openReport(socityData.list[0]['msgUrl'])">
              <div class="ESG_report">
                <div class="ESG_img"><img class="report_img" :src="socityData.list[0]['imageUrl']"></div>
                <!--<div class="ESG_img"><img class="report_img" src="../../../assets/img/111.jpg"></div>-->
                <div class="ESG_name">
                  <div class="ESG_title">{{socityData.list[0]['year']}} {{socityData.list[0]['title']}}</div>
                  <div class="ESG_icon"><i class="iconfont icon-website-PDF"></i>PDF</div>
                </div>
              </div>

              <div class="report_title" style="display: none;">
                <div class="report_year">{{socityData.list[0]['year']}}</div>
                <div class="report_name">{{socityData.list[0]['title']}}</div>
                <i class="iconfont icon-website-PDF"></i>
              </div>
            </div>
            <div class="talk_box">
              <div class="talk_title">{{ $t('society.report.chairman.title') }}</div>
              <div class="talk_word">
                {{ $t('society.report.chairman.para1') }}
                <br><br>
                {{ $t('society.report.chairman.para2') }}
              </div>
              <div class="talk_sign">
                <div>{{ $t('society.report.chairman.name') }}</div>
                <div>{{ $t('society.report.chairman.position') }}</div>
              </div>
            </div>
          </div>
        </div>
        <!--历年报告-->
        <div class="about_yewu_layout">
          <div class="baogao_width">
            <div class="web_title">{{ $t('society.report.yearlyTitle') }}</div>
            <div class="baogaolist_box">
                <div v-for="report,index in showList" class="baogao_list" :key="index" @click="openReport(report['msgUrl'])">
                  <div class="fengmian"><img :src="report.imageUrl"></div>
                  <div class="text">
                    <div class="year">{{report.year}}</div>
                    <div class="name_text">{{report.title}}</div>
                  </div>
                </div>
            </div>
            <div class="pageself" v-if="showList && showList.length > 0">
                  <paginate
                    :pageCount="pageCount"
                    :containerClass="'pagination'"
                    :page-range="3"
                    :clickHandler="pageClick"
                    :first-last-button="false"
                    :prevText="'<'"
                    :nextText="'>'"
                  >
                  </paginate>
              </div>
          </div>

        </div>

        <!-- <div class="about_yewu_layout" ref="lightFund">
          <div class="yewu_box">
            <div class="web_title">科技点亮公益</div>
            <div class="jijin_img_layout">
              <div class="jijin_list_box">
                <div class="jijin_img">
                  <img src="../../../assets/img/society/keji-2.jpg">
                </div>
                <div class="jijin_text_box">
                  <div class="jijin_title">标题标题标题标题</div>
                  <div class="jijin_word">新升级WPS冬奥版，支持组委会协同编辑电子文档完成工作，助力中国成功实现冬奥会碳排放全部中和目标。</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
              </div>
              <div class="jijin_list_box">
                <div class="jijin_img">
                  <img src="../../../assets/img/society/keji-2.jpg">
                </div>
                <div class="jijin_text_box">
                  <div class="jijin_title">标题标题标题标题</div>
                  <div class="jijin_word">新升级WPS冬奥版，支持组委会协同编辑电子文档完成工作，助力中国成功实现冬奥会碳排放全部中和目标。</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="about_wenhua_layout" ref="buildFuture">
          <div class="web_title">{{ $t('society.esg.title') }}</div>

          <div class="esg_div_box">
            <div class="esg_list_box" v-for="(rating, ri) in $t('society.esg.ratings')" :key="'r'+ri">
              <div class="esg_left">
                <div class="left_icon"><i class="iconfont icon-website-esg"></i></div>
                <div class="left_name">{{ rating.label }}</div>
              </div>
              <div class="esg_fen" v-for="(score, si) in rating.scores" :key="'s'+si">{{ score }}</div>
            </div>
            <div class="esg_list_box can_touch" v-for="(award, ai) in $t('society.esg.awards')" :key="'a'+ai" @click="openEsg(award.file, award.name)">
              <div class="esg_left" style="width:100%">
                <div class="left_icon"><i class="iconfont icon-website-jiangxiang"></i></div>
                <div class="left_name">{{ award.name }}</div>
              </div>
              <div class="esg_fen"></div>
            </div>
          </div>

        </div>

      </div>


      </main>
      <footer-build @gotoBody="gotoBody"></footer-build>


    </div>
  </template>
  <script>

  import UtilEvent from '../utils/UtilEvent.js'

    export default {
      name: 'society',
      components:{UtilEvent},
      props: {

      },
      created(){

      },
      data () {
        return {
          pageCount:1,
          perPage:4,
          oldScrollTop:0,
          isShowTopTitle:true,
          showSecondTitle:false,
          lockSecondTop:false,
          topDivHeight:0,
          socityData:{total:0,list:[]},
          listShift:[],
          showList:[],
          selectedSecond:'report'
        }
      },
      computed:{

      },
      methods:{
        gotoBody(){
          this.$refs.parentDiv.scrollIntoView({
              behavior: "smooth",  // 平滑过渡
          });
        },
        openReport(url){
          window.open(url,'_blank')
        },
        pageClick(num){
          this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.listShift)
        },
        gotoPoint(point,item){
          let offset = this.$refs[point].offsetTop;
          window.scrollTo({
              top:offset - 60,
              behavior: "smooth",  // 平滑过渡
          });
          setTimeout(()=>{
            this.selectedSecond = item;
          },900)
        },
        scrolling(){
          //获取dom滚动距离
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                      document.body.scrollTop;
          if(scrollTop >= this.topDivHeight){
            this.lockSecondTop = true;
          }else{
            this.lockSecondTop = false;
          }
          let scrollStep = scrollTop - this.oldScrollTop;
          this.oldScrollTop = scrollTop;
          if(!this.lockSecondTop){
            //scrollTop <= this.topDivHeight - 64 此距离是为了避免点击页签时候页面向上时候会把第一个导航漏出来
            if (scrollStep < 0 && (scrollTop <= this.topDivHeight - 64)) {
                this.isShowTopTitle = true;
            } else {
              if(scrollStep > 10){
                this.isShowTopTitle = false;
              }
            }
          }else{
            this.isShowTopTitle = false;
            this.handlerDivsListener();
          }

        },
        clickSecondHandler(name){
          if(name == 'foundation'){
            window.open('https://www.kingsoftfoundation.com/','_blank')
          }
        },
        handlerDivsListener(){

          let arrayName = ["report","esg"];
          let array = ["report","buildFuture"];
          let prePos = Math.abs(this.$refs[array[0]].getBoundingClientRect().top);
          this.selectedSecond = arrayName[0];
          for(let i = 1;i < array.length;i++ ){
            let temp = this.$refs[array[i]].getBoundingClientRect().top
            let offsetTop = Math.abs(temp);
            if((temp - 58 <= 0) && (offsetTop < prePos)){
              prePos = offsetTop;
              this.selectedSecond = arrayName[i];
            }
          }

        },
        openEsg(url,title){
          const newWidown = window.open("/iksnet_api/images/" + url,title);
          newWidown.document.title = title;
        },
        onLangChange() {
          new UtilEvent().getSocityInfo(this);
        }

      },
      watch:{
        '$i18n.locale'() {
          new UtilEvent().getSocityInfo(this);
        }
      },
      mounted(){
        //获得头部div高度
        this.topDivHeight = this.$refs.topDiv.offsetHeight;
        //刚加载页面后会有偏移量，便宜后再去监听
        setTimeout(()=>{
          window.addEventListener("scroll", this.scrolling)
        },300)
        new UtilEvent().getSocityInfo(this);

      },
      destroyed() {
        window.removeEventListener("scroll", this.scrolling);
      },
    }
    </script>
